import { useNavigate, useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { SemiCircleProgress } from "react-semicircle-progressbar";
import {
  CommonImages,
  ProfileImages,
  UserAuqisitation,
  UserEngagement,
} from "../../../../reusableUI/images";
import Card from "../../../../reusableUI/CommonCardUi";
import SmallCard from "../../../../reusableUI/smallCard";
import CommonDropdown from "../../../../reusableUI/dropdown";
import Pagination from "@mui/material/Pagination";
import BookingChart from "../../../../Charts/bookingChart";
import PatientsAgeChart from "../../../../Charts/charts";
import PatientGenderChart from "../../../../Charts/patientGenderChart";
import DonutChart from "../../../../Charts/donutChart";
import BookingsBySpecialist from "../../../../Charts/bookingSpeciality";
import { getBookingsDetails } from "../../../../Service/bookings";
import ServiceChart from "../../../../Charts/serviceChart";
import AreaChart from "../../../../Charts/areaChart";
import moment from "moment";
import TabButtons from "../../../../reusableUI/tabButtons";
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
} from "../../../../utils/Functions";
import UnassignedBookings from "./unassignedBookings";

const Booking = () => {
  const [card, setCard] = useState("1");
  const [option, setOption] = useState("Analytics");
  const [selectedValue, setSelectedValue] = useState("Last 30 days");
  const [paginationPage, setPaginationPage] = useState(0);
  const [bookingsDetaile, setBookingsDetaile] = useState([]);
  const [filteredBookingList, setFilteredBookingList] = useState([]);
  const [filteredPhysio, setFilteredPhysioList] = useState([]);
  const [filteredNurse, setFilteredNurseList] = useState([]);
  const [booked, setBooked] = useState([]);
  const [ageChart, setAgeChart] = useState([]);
  const [services, setServices] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [accepted, setAccepted] = useState([]);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Analytics");
  const [repeated, setRepeated] = useState([]);
  const [newBookingCount, setNewBookingCount] = useState();

  useEffect(() => {
    getBooking();
  }, []);
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem(card)) {
      setSelectedTab(localStorage.getItem(card));
    }
  }, [location.state]);

  const getBooking = async () => {
    const result = await getBookingsDetails();
    console.log(result);
    if (!result.error) {
      setBookingsDetaile(result.data);
      setBooked(result.data.bookings);

      const nurse = result.data.bookings.filter(
        (item) => item?.specialistInfo?.role === "nurse"
      );
      const physio = result.data.bookings.filter(
        (item) => item?.specialistInfo?.role === "physiotherapist"
      );

      setFilteredNurseList(nurse);
      setFilteredPhysioList(physio);
    }
  };
  console.log(bookingsDetaile);
  const options = [
    { label: "Today", value: "Today" },
    { label: "Last 7 days", value: "Last 7 days" },
    { label: "Last 30 days", value: "Last 30 days" },
    { label: "Over All", value: "Over All" },
  ];

  const liveOptions = [
    { label: "All", value: "live-all" },
    { label: "Not Started", value: "live-notStarted" },
    { label: "Duty Started", value: "live-startDuty" },
    { label: "Duty Ended", value: "live-endDuty" },
    // { label: "Accepted", value: "live-accepted" },
  ];

  const statusOptions = [
    { label: "All", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Rejected", value: "rejected" },
    { label: "Completed", value: "completed" },
    { label: "Not Available", value: "not available" },
    { label: "Expired", value: "expired" },
    { label: "Payment Pending", value: "payment pending" },
    { label: "Not Paid", value: "not paid" },
    { label: "Accepted", value: "accepted" },
    { label: "Duty Started", value: "startDuty" },
    { label: "Duty Ended", value: "endDuty" },
    { label: "In Complete", value: "incomplete" },
  ];

  const handleTimeframeChange = (e) => {
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    const filterUsersByTimeframe = (users, timeframe) => {
      const now = new Date();
      let startDate;

      if (timeframe === "Today") {
        startDate = new Date(now.setHours(0, 0, 0, 0));
      } else if (timeframe === "Last 7 days") {
        startDate = new Date(now.setDate(now.getDate() - 7));
      } else if (timeframe === "Last 30 days") {
        startDate = new Date(now.setDate(now.getDate() - 30));
      } else if (timeframe === "Over All") {
        return users;
      }

      return users.filter((user) => new Date(user.createdAt) >= startDate);
    };

    const filteredList = filterUsersByTimeframe(booked, selectedValue);
    const accepted = filteredList.filter((item) => item.status === "accepted");
    setAccepted(accepted);
    setFilteredBookingList(filteredList);
  }, [selectedValue, booked]);

  useEffect(() => {
    const usersWithAge = filteredBookingList
      .filter(
        (item) => item?.patient?.userID?.personalInfo?.basicInfo?.otherInfo?.dob
      )
      .map((item) => {
        const dob = new Date(
          item.patient.userID.personalInfo.basicInfo.otherInfo.dob
        );
        const age = new Date().getFullYear() - dob.getFullYear();
        return {
          age,
          createdAt: item.createdAt,
          gender: item.patient.userID.personalInfo.basicInfo.otherInfo.gender,
          services: item.visitInfo.services,
        };
      });

    setAgeChart(usersWithAge);
    const servicesWithDate = filteredBookingList
      .filter(
        (item) =>
          item?.visitInfo?.services && Array.isArray(item?.visitInfo?.services)
      )
      .flatMap((item) =>
        item?.visitInfo?.services.map((service) => ({
          service,
          createdAt: item.createdAt,
        }))
      );

    setServices(servicesWithDate);

    const getArea = filteredBookingList
      .filter((item) => item?.visitInfo.addressInfo?.district)
      .map((item) => ({
        city: item?.visitInfo.addressInfo?.district,
        createdAt: item.createdAt,
      }));

    setAreas(getArea);

    const newBookings = filteredBookingList.map((item) => {
      const newBooking = item?.createdAt;
      return newBooking;
    });
    const newBookingCount = newBookings.length;
    // console.log(newBookingCount);
    setNewBookingCount(newBookingCount);

    const countRepeat = filteredBookingList.reduce((acc, item) => {
      const patientId = item?.patient?.patientID;

      if (patientId) {
        acc[patientId] = (acc[patientId] || 0) + 1;
      }
      return acc;
    }, {});

    const counts = Object.values(countRepeat);
    setRepeated(counts);
  }, [filteredBookingList]);

  const repeatedBookingsCount = repeated.filter((count) => count > 1).length;
  const totalBookingsCount = booked.length;

  const percentage = (repeatedBookingsCount / totalBookingsCount) * 100;
  // console.log(percentage);

  let conversion = (accepted.length / filteredBookingList.length) * 100;
  conversion = Math.round(conversion);

  const handleChange2 = (event, value) => {
    setPaginationPage(value - 1);
  };

  const handleStatusFrame = (e) => {
    setSelectedStatus(e.target.value);
  };

  const onSelect = (option) => {
    setSelectedTab(option);
  };

  const getColumns = () => {
    let baseColumns = [
      {
        Header: "Patient Name",
        accessor: "name",
        Cell: ({ row: { original } }) => (
          <div className="flex items-center">
            <img
              src={
                original?.patient?.userID?.personalInfo?.basicInfo?.otherInfo
                  ?.gender == "male"
                  ? original.profilePicture || CommonImages.male
                  : original.profilePicture || CommonImages.female
              }
              alt="profile"
              className="h-8 w-8 rounded-full mr-1"
            />
            <p className=" text-[12px] max-w-[100px] truncate">
              {original?.patient?.name || "not available"}
            </p>
          </div>
        ),
      },
      {
        Header: "Gender",
        accessor: "gender",
        Cell: ({ row: { original } }) => (
          <p className="text-gray-500 text-[12px]">
            {capitalizeFirstLetter(original?.patient?.gender) ||
              "not available"}
          </p>
        ),
      },
      {
        Header: "Contact No.",
        accessor: "contact",
        Cell: ({ row: { original } }) => {
          const phone =
            original?.patientID?.personalInfo?.basicInfo?.otherInfo?.phone;

          return phone ? (
            <p>{formatPhoneNumber(phone)}</p>
          ) : (
            <p className="text-gray-500 text-[12px]">Not Available</p>
          );
        },
      },
      {
        Header: "Specialist Name",
        accessor: "specialist",
        Cell: ({ row: { original } }) => (
          <div className="flex flex-row items-center">
            <div
              className={`flex items-center justify-center rounded-full text-white p-2 w-8 h-8
          ${original?.specialistInfo?.role === "nurse"
                  ? "bg-[#d7e4f7]"
                  : "bg-[#c8fad0]"
                }`}
            >
              <p className="text-[#1863db]">
                {original?.specialistInfo?.role === "nurse" ? "N" : "PY"}
              </p>
            </div>
            <p className="ml-2 text-gray-500 text-[12px]">
              {original?.specialistInfo?.name || "not available"}
            </p>
          </div>
        ),
      },
      {
        Header: "Start Date",
        accessor: "date",
        Cell: ({ row: { original } }) => (
          <p className="text-gray-500 text-[12px]">
            {original.dutyInfo[0]?.date ? original.dutyInfo[0]?.date : "NA"}
          </p>
        ),
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: ({ row: { original } }) => (
          <div>
            <p className="text-gray-500 text-[12px]">
              {original?.patient?.userID?.personalInfo?.addressInfo?.city ||
                "not available"}
            </p>
          </div>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row: { original } }) => (
          <div>
            <p className="text-[12px]">
              {original.status === "endDuty"
                ? "End Duty"
                : original.status === "pending"
                  ? "Pending"
                  : original.status === "startDuty"
                    ? "Start Duty"
                    : original.status === "accepted"
                      ? "Not Started"
                      : original.status === "payment pending"
                        ? "Payment Pending"
                        : original.status === "completed"
                          ? "Completed"
                          : original.status === "cancelled"
                            ? "Cancelled"
                            : original.status === "not paid"
                              ? "Payment Pending"
                              : (original.status === original.status) !== "completed" &&
                                original.visitInfo?.endDuty &&
                                new Date(original.visitInfo.endDuty) < new Date()
                                ? "InCompleted"
                                : "Status not available"}
            </p>
          </div>
        ),
      },
      {
        Header: "Profile",
        accessor: "profile",
        Cell: ({ row: { original, index } }) => (
          <button
            className="text-indigo-500 bg-white hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-3 py-1 rounded"
            onClick={() =>
              navigate(`/admin/bookingsProfile/${original._id}`, {
                state: { user: original, card: selectedTab }, // pass card in state
              })
            }
          >
            View
          </button>
        ),
      },
    ];

    return baseColumns;
  };

  const filteredData = useMemo(() => {
    const today = moment().startOf("day");
    const currentDate = moment();

    const isWithinVisitDates = (startDate, endDate, dutyType) => {
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).startOf("day");

      if (dutyType === "oneTime") {
        return today.isSame(start) && today.isSame(end);
      }

      const adjustedStart = moment(startDate).add(1, "day").startOf("day");
      return today.isSameOrAfter(adjustedStart) && today.isSameOrBefore(end);
    };

    const hasDutyStatus = (dutyInfo, startVerified, endVerified) =>
      dutyInfo.some(
        (duty) =>
          moment(duty.date).isSame(currentDate, "day") &&
          duty.startDuty.verified === startVerified &&
          duty.endDuty.verified === endVerified
      );
    console.log(selectedStatus);
    switch (selectedStatus) {
      case "all":
        return booked;

      case "accepted":
        return booked.filter((item) => item.status === "accepted");

      case "startDuty":
        return booked.filter((item) =>
          hasDutyStatus(item.dutyInfo, true, false)
        );

      case "endDuty":
        return booked.filter((item) =>
          hasDutyStatus(item.dutyInfo, true, true)
        );

      case "pending":
        return booked.filter((item) => item.status === "pending");

      case "rejected":
        return booked.filter((item) => item.status === "rejected");

      case "completed":
        return booked.filter((item) => item.status === "completed");

      case "not available":
        return booked.filter((item) => item.status === "not available");

      case "expired":
        return booked.filter((item) => item.status === "expired");

      case "payment pending":
        return booked.filter(
          (item) => !item.paymentInfo.paid && item.status === "payment pending"
        );

      case "not paid":
        return booked.filter(
          (item) => !item.paymentInfo.paid && item.status === "not paid"
        );

      case "incomplete":
        return booked.filter((item) => {
          const endDate = moment(item.visitInfo.endDate);
          return currentDate.isAfter(endDate) && item.status !== "completed";
        });

      case "live-notStarted":
        return booked.filter(
          (item) =>
            item.status === "accepted" &&
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType
            ) &&
            hasDutyStatus(item.dutyInfo, false, false)
        );

      case "live-startDuty":
        return booked.filter(
          (item) =>
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType
            ) && hasDutyStatus(item.dutyInfo, true, false)
        );

      case "live-endDuty":
        return booked.filter(
          (item) =>
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType
            ) && hasDutyStatus(item.dutyInfo, true, true)
        );
      case "live-all":
        return booked.filter((item) =>
          isWithinVisitDates(
            item.visitInfo.startDate,
            item.visitInfo.endDate,
            item.dutyType
          )
        );

      default:
        return booked;
    }
  }, [selectedStatus, booked]);

  // console.log(bookingsDetaile);
  // console.log("filteredData", filteredData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex },
    gotoPage,
  } = useTable(
    {
      columns: useMemo(() => getColumns(), [selectedStatus]),
      data: filteredData,
      initialState: { pageSize: 12, pageIndex: paginationPage },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    gotoPage(paginationPage);
  }, [paginationPage, gotoPage, filteredData]);
  // console.log(filteredData);

  const tabOptions = [
    { value: "Analytics", label: "Analytics", count: 0 },
    { value: "Booking List", label: "Booking List", count: 0 },
  ];

  const onClick = (c) => {
    setCard(c);
  };

  return (
    <div className="overflow-y-auto overflow-x-hidden bg-[#F3F6F5] w-[100%] h-[90vh] mb-10 pb-10">
      <div className="flex flex-row justify-center items-center w-[99%]">
        <Card
          title={"Total Bookings"}
          image={CommonImages.TotalBooking}
          image1={CommonImages.Up}
          count={bookingsDetaile.totalBookings}
          text={`${bookingsDetaile.successfulBookings} successful bookings out of ${bookingsDetaile.totalBookings} bookings`}
          page={card}
          id="1"
          onClick={() => onClick("1")}
          user={"booking"}
        />
        <Card
          title={"Unassigned Bookings"}
          image={CommonImages.report}
          image1={CommonImages.Up}
          count={booked.filter((item) => item.assigned === false).length}
          text={"Higher than usual"}
          page={card}
          id="2"
          onClick={() => onClick("2")}
          user={"booking"}
          card={"booking2"}
        />
        <Card
          title={"Cancelled Booking"}
          image={CommonImages.success}
          image1={UserAuqisitation.down}
          count={bookingsDetaile.cancelledBookings}
          text={"Average number of sessions per user"}
          page={card}
          onClick={() => onClick("3")}
          id="3"
          user={"booking"}
          card={"booking2"}
        />
      </div>
      {card === "1" && (
        <>
          <TabButtons
            options={tabOptions}
            selectedOption={selectedTab}
            onSelect={onSelect}
          />
          {selectedTab === "Analytics" && (
            <div className=" h-[63vh]  mb-8">
              <div className="bg-white rounded-2xl shadow-md h-85 m-2">
                <div className="flex justify-between items-center p-2">
                  <p className="text-[14px] ml-5 mt-[-5px] font-semibold">
                    Number of Bookings
                  </p>

                  <CommonDropdown
                    options={options}
                    value={selectedValue}
                    onChange={handleTimeframeChange}
                  />
                </div>
                <div className="border-b border-[#D7E4EB] mb-2 mt-[-5px]"></div>
                <div className="text-center mt-5">
                  <p className="text-2xl font-bold">
                    {filteredBookingList.length}
                  </p>
                  <p className="text-sm text-[#1D1D22] mt-0">Total Bookings</p>
                </div>
                <div className="flex flex-row m-4">
                  <SmallCard
                    image1={UserEngagement.chart}
                    status={"Booking Conversion Rate"}
                    count={
                      isNaN(conversion) || conversion === 0
                        ? "0%"
                        : conversion + "%"
                    }
                    image2={CommonImages.Up}
                  />
                  <SmallCard
                    image1={CommonImages.calender}
                    status={"Successfull bookings"}
                    count={accepted.length}
                    image2={CommonImages.Up}
                  />
                </div>
                {/* <div className="flex flex-row mt-[-28px] m-4">
              <SmallCard
                image1={pending}
                status={"Pending requests"}
                count={"78"}
                rating={"+2.7%"}
              />
              <SmallCard
                image1={calender}
                status={"Cancelled Bookings"}
                count={"78"}
                rating={"-1.4%"}
              />
            </div> */}
              </div>

              <div className="bg-white rounded-2xl shadow-md m-2 mt-[-5px]">
                <div className="flex justify-between items-start">
                  <p className="text-[14px] ml-3 p-3 font-semibold">Bookings</p>
                </div>
                <div className="border-b border-[#D7E4EB] mb-1 "></div>
                <div className="p-2 mt-4">
                  <BookingChart
                    bookingsData={filteredBookingList}
                    value={selectedValue}
                  />
                </div>
              </div>
              <div className="flex justify-row mb-3 gap-1 mt-3  w-full">
                <div className="mini-card bg-white w-1/3  rounded-2xl shadow-md pb-2 mx-2">
                  <p className="text-[14px] ml-3 font-semibold p-2 mt-1">
                    Patients Booking By Age
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row items-center pl-4 mt-2">
                    <img
                      src={CommonImages.ageI}
                      className="h-2 w-2"
                      alt="Age Icon"
                    />
                    <p className="text-[12px] ml-2">Patients</p>
                  </div>
                  <div className="ml-2 mt-10">
                    <PatientsAgeChart
                      ageData={ageChart}
                      value={selectedValue}
                    />
                  </div>
                </div>

                <div className=" bg-white w-1/3 rounded-2xl shadow-md  pb-3">
                  <p className="text-[16px] md:text-[14px] p-2 ml-3 font-semibold mt-1">
                    Repeated Bookings
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row justify-center mt-10 p-1">
                    <SemiCircleProgress
                      percentage={
                        isNaN(percentage) || percentage === 0
                          ? "0"
                          : percentage.toFixed(0) + "%"
                      }
                      size={{
                        width: 120,
                        height: 120,
                      }}
                      strokeWidth={7}
                      strokeColor={"#FFCD71"}
                      bgStrokeColor={"#FDF0D8"}
                      hasBackground={"#FDF0D8"}
                      strokeLinecap={"square"}
                    />
                  </div>
                  <p className="text-center mt-2 text-[12px] md:text-[14px] mx-8">
                    {repeatedBookingsCount} repeated bookings out of{" "}
                    {booked.length}
                  </p>
                </div>

                {/* Patients Bookings by Gender Card */}
                <div className="mini-card-b bg-white  w-1/3 rounded-2xl shadow-md pb-3 mx-2">
                  <p className="text-[14px] ml-3 font-semibold mt-1 p-2">
                    Patients Bookings by Gender
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row items-center justify-center">
                    <PatientGenderChart
                      ageData={ageChart}
                      value={selectedValue}
                    />
                  </div>
                </div>
              </div>

              <ServiceChart value={selectedValue} data={services} />

              <div className="flex flex-row w-[100%] mt-[12px]  align-center pb-6">
                <div className="flex w-full h-[35vh]">
                  <DonutChart
                    newBookings={newBookingCount}
                    oldBookings={newBookingCount - filteredBookingList.length}
                  />
                  <BookingsBySpecialist
                    value={selectedValue}
                    nurseData={filteredNurse}
                    physioData={filteredPhysio}
                  />
                  {/* <PatientsBookingArea /> */}
                  <AreaChart value={selectedValue} data={areas} />
                </div>
              </div>
            </div>
          )}

          {selectedTab === "Booking List" && (
            <div className="bg-white p-3 rounded-2xl shadow-lg mb-3 mx-2 h-[80vh] mt-2 w-[99%]">
              <div className="flex justify-between items-center mt-[-10px]">
                <p className="text-lg ml-4 font-semibold">
                  {selectedStatus && `Booking List (${filteredData.length})`}
                </p>
                <div className="flex flex-col mb-4 mt-4 relative">
                  <select
                    id="live-status"
                    value={selectedStatus}
                    onChange={handleStatusFrame}
                    className="border rounded-md text-[12px] text-[blue] border-blue-600 py-1 px-3 pr-8 appearance-none "
                    style={{ borderWidth: 1.5 }}
                  >
                    <option disabled>Live</option>
                    {liveOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}

                    <option disabled>Status</option>
                    {statusOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>

                  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-blue-600">
                    <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                      <path d="M7 10l5 5 5-5H7z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-between">
                <div className="overflow-x-auto h-[63vh]">
                  <table {...getTableProps()} className="w-full min-w-[600px]">
                    <thead>
                      {headerGroups.map((hg) => (
                        <tr {...hg.getHeaderGroupProps()} key={hg.id}>
                          {hg.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              key={column.id}
                              className="bg-gray-100 text-[#8177A8] text-left text-[12px] p-2"
                            >
                              {column.render("Header")}
                              <img
                                src={ProfileImages.filter}
                                className="inline-block h-3 w-2 ml-1"
                              />
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="bg-white">
                      {tablePage.map((row) => {
                        prepareRow(row);
                        return (
                          <tr
                            {...row.getRowProps()}
                            key={row.id}
                            className="hover:bg-gray-50"
                          >
                            {row.cells.map((cell) => (
                              <td
                                {...cell.getCellProps()}
                                key={cell.column.id}
                                className="p-1.5 text-[14px] border-b border-[#D7E4EB]"
                              >
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="flex justify-between items-center mt-4 mb-2 px-4">
                  <Pagination
                    count={pageOptions.length}
                    page={paginationPage + 1}
                    color="primary"
                    onChange={handleChange2}
                    size="small"
                    classes={{
                      ul: "flex justify-center",
                      li: "flex items-center",
                      selected: "bg-indigo-500 text-white",
                    }}
                    hideNextButton
                    hidePrevButton
                  />

                  <div className="flex items-center space-x-4">
                    <button
                      onClick={previousPage}
                      disabled={!canPreviousPage}
                      className="text-blue-500 bg-white flex items-center cursor-pointer"
                    >
                      <img
                        src={ProfileImages.prev}
                        alt="prev icon"
                        className="h-4 w-4 mr-1"
                      />
                      <p className="text-sm">Previous</p>
                    </button>

                    <button
                      onClick={nextPage}
                      disabled={!canNextPage}
                      className="text-blue-500 bg-white flex items-center cursor-pointer"
                    >
                      <p className="text-sm">Next</p>
                      <img
                        src={ProfileImages.next}
                        alt="next icon"
                        className="h-4 w-4 ml-1"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {card === "2" && (
        <div className=" ">
          <UnassignedBookings data={bookingsDetaile} />
        </div>
      )}

      {card === "3" && (
        <div className="flex justify-center items-center h-[60vh]">
          <img src={CommonImages.comingSoon} alt="Coming Soon" />
        </div>
      )}
    </div>
  );
};
export default Booking;
